<template>
  <div>
    <p class="msg" style="margin: 0px;">
      <awesomeIcon icon="exclamation-circle" />
      Klant heeft machtiging geaccepteerd
      {{Number($store.state.role) === 2 ? '' : ', nog geen intake gestart'}}
    </p>
    <div class="card" v-if="$parent.clientsAccepted !== null">
      <div class="row menubar">
        <input
          type="text"
          v-model="search"
          ref="search"
          placeholder="Zoeken"
          @keyup="updateSearch"
          class="searchbar"
        />
        <!-- type sorting -->
        <div class="dropdown nowrap" style="float:right;">
          <button class="dropdown-button" @click="dropdownlist = !dropdownlist">
            <awesomeIcon icon="sort" /> {{ orders[order] }}
          </button>
          <div
            class="dropdown-bg"
            v-if="dropdownlist"
            @click="dropdownlist = !dropdownlist"
          ></div>
          <ul class="dropdown-list" v-if="dropdownlist">
            <li
              v-for="(groupname, group) in orders"
              :key="groupname"
              @click="
                dropdownlist = !dropdownlist;
                chooseOrder(group);
              "
            >
              {{ groupname }}
            </li>
            <li class="dropdown-cancel" @click="dropdownlist = !dropdownlist">Annuleren</li>
          </ul>
        </div>
      </div>
      <table width="100%">
        <thead class="table-legend">
          <tr>
            <th>Naam</th>
            <th>E-mailadres</th>
            <th></th>
          </tr>
        </thead>
        <tr v-for="(client, index) in slice(
            filter($parent.clientsAccepted, searchFilter),
            currentPage * resultsPerPage, (
              currentPage + 1
            ) * resultsPerPage
          )"
          :key='`client${index}`'
        >
          <td>{{client.name}}</td>
          <td>{{client.email}}</td>
          <td style="float:right;">
            <button @click="$parent.becomeUser(client.client)" class="secondary hide-mobile">
              <awesomeIcon icon="search"/> Bekijk
            </button>
          </td>
        </tr>
      </table>
      <pagerElement
        v-model="currentPage"
        :records="filter($parent.clientsAccepted, searchFilter).length"
        :resultsPerPage="resultsPerPage"
      />
    </div>
  </div>
</template>

<script>
import { filter, slice } from 'lodash-es';

export default {
  name: 'OnboardingAuthorized',
  data() {
    return {
      search: '',
      order: 'name',
      orders: {
        name: 'Naam',
        email: 'E-mail',
      },
      dropdownlist: false,
      currentPage: 0,
      resultsPerPage: 20,
    };
  },
  methods: {
    filter,
    slice,
    chooseOrder(group) {
      this.dropdownlist = false;
      this.order = group;
    },
    updateSearch() {
      this.currentPage = 0;
      this.search = this.$refs.search.value.toLowerCase();
    },
    searchFilter(obj) {
      const trimmedSearch = this.search.trim();
      if (obj.name.toLowerCase().indexOf(trimmedSearch) > -1) {
        return true;
      }
      if (obj.email.toLowerCase().indexOf(trimmedSearch) > -1) {
        return true;
      }
      return false;
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
